<template>
    <div class="msg">
         <div v-show="visible && type === 'success'" class="success popout_show">
             {{txt}}
        </div>
         <div v-show="visible && type === 'fail'" class="fail popout_show">
             {{txt}}
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
            txt:'',
            type:'',
            visible:false,
        };
    },
};
</script>
<style lang='less' scoped>
.msg{
    .popout_show{
        position:absolute;
        z-index:10000;
        top:10px;
        left:50%;
        // transform:translateX(-45%);  这里位置不在正中间
        margin-left:-100px;
        width:350px;         //这个div有宽度和高度
        height:70px;  
        background:#fff;
        font-size:20px;
        // color:#fff;
        text-align:center;
        line-height:70px;
        animation: showMsg 2.5s;
        -moz-animation:showMsg 2.5s;
        -webkit-animation:showMsg 2.5s;
        -o-animation:showMsg 2.5s;
    }
    .success{
        color:#12d843;
        // border:1px solid green;
        border-radius:5px;
    }
    .fail{
        color:#d30f0f;
        border-radius:5px;
    }
    @keyframes showMsg{
        0%{transform: scale(0.2);opacity: 0;}
	100%{ transform: scale(1);opacity: 1;}


    }
    @-moz-keyframes showMsg{
        0%{transform: scale(0.2);opacity: 0;}
	100%{ transform: scale(1);opacity: 1;}

    }
    @-webkit-keyframes showMsg{
        0%{transform: scale(0.2);opacity: 0;}
	100%{ transform: scale(1);opacity: 1;}

    }
    @-o-keyframes showMsg{
          0%{transform: scale(0.2);opacity: 0;}
	100%{ transform: scale(1);opacity: 1;}

    }
}
</style>




// WEBPACK FOOTER //
// src/components/common/msg.vue